import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { ScrollProgress, WhatsAppFab } from "@/components/landing/Floating";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import ServiceDetailTemplate from "@/pages/ServiceDetailTemplate";

const normalize = (row) => ({
  slug: row.slug,
  category: row.category,
  icon: row.icon,
  image: row.image,
  title: row.title,
  subtitle: row.subtitle,
  readTime: row.read_time,
  intro: row.intro,
  ...row.sections,
});

export default function RegistrationServiceDetail() {
  const { slug } = useParams();
  const { isAdmin } = useAuth();
  const [service, setService] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    Promise.all([api.getService(slug), api.listServices("Registration")])
      .then(([{ service }, { services }]) => {
        if (service.category !== "Registration") throw new Error("Not a registration service");
        setService(normalize(service));
        setAllServices(services);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (notFound) return <Navigate to="/registration" replace />;

  const contactHref = "/contact";
  const uploadHref = service
    ? `/upload?service=${encodeURIComponent(service.slug)}&category=Registration&title=${encodeURIComponent(service.title)}`
    : "/upload";
  const relatedItems = service
    ? (service.related || [])
        .map((relSlug) => allServices.find((s) => s.slug === relSlug))
        .filter(Boolean)
        .map((r) => ({ slug: r.slug, title: r.title, icon: r.icon, href: `/registration/${r.slug}` }))
    : [];

  return (
    <div className="relative min-h-screen bg-white font-sans text-navy-900 antialiased" data-testid="registration-service-page">
      <ScrollProgress />
      <Navbar />
      <main>
        {loading || !service ? (
          <div className="pt-40 pb-20 text-center text-slate-500">Loading...</div>
        ) : (
          <ServiceDetailTemplate
            service={service}
            accentKey="gold"
            breadcrumbs={[{ label: "Registration", href: "/registration" }]}
            contactHref={contactHref}
            uploadHref={uploadHref}
            showUpload={!isAdmin}
            relatedItems={relatedItems}
          />
        )}
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
